import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthContext';
import { CustomerAccountNotice } from '@/features/auth/components/CustomerAccountNotice';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, accountKind, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Načítání...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // ADR 0011: the portal is a partner's door. Only the recorded customer kind is
  // refused — an account older than the column has no kind and keeps its portal.
  if (accountKind === 'customer') {
    return <CustomerAccountNotice />;
  }

  return <>{children}</>;
}
